import { render, staticRenderFns } from "./CustomerLabel.vue?vue&type=template&id=2ca50398&"
import script from "./CustomerLabel.vue?vue&type=script&lang=js&"
export * from "./CustomerLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports